<template>
  <div>
<!--    <div v-if="settings.theme.input.sublabel" class="text-body2 mw-form-v2-label" v-html="field.label"></div>-->
    <q-field
        borderless
        v-model="fieldValue"
        :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
    >
    <div class="q-py-sm q-gutter-y-md q-ml-none mw-form-v2-btn-gutter">

      <template
          v-for="(option, index) in optionsForSelect"
          :key="index"
      >
        <q-btn
            class="mw-w-100 mw-form-v2-btn"
            :flat="settings.theme.button.flat"
            :rounded="settings.theme.button.rounded"
            :round="settings.theme.button.round"
            :outline="settings.theme.button.outline"
            :push="settings.theme.button.push"
            :unelevated="settings.theme.button.unelevated"
            :noCaps="settings.theme.button.noCaps"
            :glossy="settings.theme.button.glossy"
            :size="settings.theme.button.size"
            :color="fieldValue === option.value ? 'secondary' : 'primary'" :label="option.label" @click="currentVersion = screensVisibilityVersion; fieldValue = option.value"/>
      </template>

<!--      <div class="text-caption" v-html="field.description"></div>-->
    </div>
    </q-field>
  </div>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import {mapActions} from "vuex";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      value: null,
      currentVersion: null
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      next: 'values/list/next',
      nextScreen: 'values/list/nextScreen'
    }),
    // nextScreen() {
    //   if(this.field.submit_on_value_set) {
    //     const count = Object.keys(this.form.screens).length;
    //     if (count > (this.activeScreen + 1)) {
    //       this.next();
    //       while (!this.screensVisibility[this.form.screens[this.activeScreen].id] && count > (this.activeScreen + 1)) {
    //         this.next();
    //       }
    //     }
    //   }
    // },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form',
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues',
      activeScreen: 'activeScreen',
      fieldsVisibility: 'fieldsVisibility',
      screensVisibility: 'screensVisibility',
      debug: "debug",
      screensVisibilityVersion: "screensVisibilityVersion"
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select something';
    },
    optionsForSelect: function () {
      let data = [];
      for (const [key, value] of Object.entries(this.field.options)) {
        data.push( {
          label: value,
          value: key
        });
      }
      return data;
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  watch: {
    screensVisibilityVersion: function (version) {
      if(this.currentVersion === version -1 && this.field.submit_on_value_set) {
        this.nextScreen({form : this.form});
      }
    }
  },
  mounted() {

  }
}
</script>
<style>

</style>
